import React from 'react';

import {observer} from "mobx-react";
import {Link} from "../../../../../../../core/components/link/link";
import {GameCompetitorViewModel} from "../../../../../../../domain/partial-game/models/game-competitor/game-competitor-view-model";
import {EntityDisplayName} from "../../../../../../../core/components/entity-display-name";
import {ACTION_TYPES} from "../../../../../../../core/consts";
import {GameCenterHeaderModuleProps} from "../../../models/game-center-header-module.props";
import {APP} from "../../../../../../../core/app/consts";
import {Text} from "../../../../../../../core/components/misc/text/text";
import {GameCenterHeaderDetailsCompetitorBadge} from "./game-center-header.details.competitor.badge";
import {GameCenterHeaderDetailsCompetitorSeasonRecord} from "./game-center-header.details.competitor.season-record";
import styles from "../../../styles/game-center-header-competitor.module.scss"
import classNames from "classnames";

export class GameCenterHeaderDetailsCompetitorProps extends GameCenterHeaderModuleProps {
  isHomeTeam: Boolean;
  competitor: GameCompetitorViewModel;
}

export const GameCenterHeaderDetailsCompetitor = observer(({controller, isHomeTeam}: GameCenterHeaderDetailsCompetitorProps) => {
  const {state, device} = controller;
  const {isSmallView} = device;
  const {competition} = state;

  const {
    homeCompetitor,
    awayCompetitor,
    currentLinkModel,
    homeCompetitorNameAnimationClassName,
    awayCompetitorNameAnimationClassName,
    homeCompetitorPlayerNameText,
    awayCompetitorPlayerNameText,
    homeCompetitorPlayerNameAnimationClassName,
    awayCompetitorPlayerNameAnimationClassName,
    shouldRenderRanking
  } = state;

  const competitor = isHomeTeam ? homeCompetitor : awayCompetitor;
  const shouldRenderCountryName: Boolean = competition.isInternational && !competitor.isNational && !homeCompetitor.country.isInternational && !awayCompetitor.country.isInternational

  const badgeProps = {
    controller,
    isHomeTeam
  };

  const onCompetitorHeaderClick = () => {
    controller.action(ACTION_TYPES.entityClick, {
      entityId: competitor.id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[competitor.objectType],
      source: APP.ANALYTICS.SOURCES[currentLinkModel.name],
      currentLinkModel: currentLinkModel,
      sportTypeId: competitor.sport.id
    });

    return true;
  };

  const linkProps = {
    model: competitor.linkModel,
    onClick: () => onCompetitorHeaderClick(),
    className: classNames(
      styles.competitor,
      {[styles.small_view]: isSmallView},
      {[styles.country_included]: shouldRenderCountryName}
    )
  };

  const entityDisplayNameProps = {
    entity: competitor,
    numOfMaxLines: 2,
    className: classNames(
      styles.competitor_name,
      {'bold' : competitor.isWinner},
      {[homeCompetitorNameAnimationClassName]: isHomeTeam},
      {[awayCompetitorNameAnimationClassName]: !isHomeTeam},
      {[styles.name_ranking]: !!competitor.ranking && shouldRenderRanking}
    )
  };

  const playerNameProps = {
    text: isHomeTeam ? homeCompetitorPlayerNameText : awayCompetitorPlayerNameText,
    className: classNames(
      styles.player_name,
      {[homeCompetitorPlayerNameAnimationClassName]: isHomeTeam},
      {[awayCompetitorPlayerNameAnimationClassName]: !isHomeTeam},
    )
  };

  return (
    <Link {...linkProps}>
      <GameCenterHeaderDetailsCompetitorBadge {...badgeProps}/>
      <EntityDisplayName {...entityDisplayNameProps}/>
      {
        shouldRenderCountryName ? <div className={classNames(styles.country_name)}>({competitor.country.name})</div> : null
      }
      <GameCenterHeaderDetailsCompetitorSeasonRecord competitor={competitor}/>
      <Text {...playerNameProps}/>
    </Link>
  );
});
